import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const RenderWpForm = () => {

var md5 = require('md5');

var resturl=sessionStorage.getItem("RESTURL");

//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [dowait, setDowait] = useState({show:false});
const [dlwait, setDlwait] = useState({show:false});
const [modal, setModal] = useState({open:false});
const [rpt, setRpt] = useState({num:0});


const [crit, setCrit] = useState({
date1: null
, date2: null
, review_type:''
, processarea:''
, status:''	
, island:''	
});


/*<option key='staopt1' value='REFUSED' 		>REFUSED</option>*/
const [statusopts, setStatusopts] = useState([
<option key='staopt3' value='NOTSUBMIT' 	>NOT SUBMITTED</option>
,<option key='staopt4' value='NEW' 			>NEW APPLICATION</option>
,<option key='staopt2' value='VCHRSNOTPAID' >UNPAID VOUCHERS</option>
,<option key='staopt5' value='VCHRSPAID' 	>PAID VOUCHERS</option>
,<option key='staopt8' value='REVIEWED' 	>REVIEWED</option>
,<option key='staopt6' value='PROCESSING' 	>PROCESSING</option>
,<option key='staopt7' value='CANCELLED' 	>CANCELLED</option>
]);



const [processareaopts, setProcessareaopts] = useState([
<option key='pareaopt1' value='Corporate' >Corporate</option>
,<option key='pareaopt2' value='General' >General</option>
]);

const [reviewtypeopts, setReviewtypeopts] = useState([
<option key='rtopt1' value='B' >Board Review</option>
,<option key='rtopt2' value='C' >Commissioner Review</option>
]);

const location = useLocation();


useEffect(() => {
document.title =   "APS Reports";
//getmd5count

let date1 = new Date();
date1.setMonth(date1.getMonth() - 1);
date1.setDate(0);
setCrit((prev)=>{
	return {...prev
	, date1:date1.toISOString().substring(0, 10)
	, date2: new Date().toISOString().substring(0, 10)
	}
	});

 },[]);









function handleChange(e){
	//OVR_RQS_SUP
	const {name, value} = e.target;
	
		setCrit((prev)=>{
			return {...prev, [name]:value}
		});
	
	
	
}//end func


async function rptapprovedwpxl(){

let params=crit;
params.USERNAME=sessionStorage.getItem("USERNAME");
params.FIN_YR="2024/2025"
params.FILE_NAME="Approved_Work_Permits_2024-2025";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});
	
 await fetch(resturl+'rarxlreport/rptapprovedwpxl',requestOptions)
      .then(res => 	afterrptapprovedwpxl(res) )
      .catch(err => console.log(err));	
	
}//end func

async function afterrptapprovedwpxl(res){
	//var blob = new Blob(res, {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
	setDowait({show:false});
	
	const blob = await res.blob();
saveAs(blob, dateandtimestring()+".xlsx", {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
//.substring(0, 10)
}//end func



async function rptwptappsxl(){

let params=crit;
params.USERNAME=sessionStorage.getItem("USERNAME");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});
	
 await fetch(resturl+'rarxlreport/rptwptappsxl',requestOptions)
      .then(res => 	afterrptwptappsxl(res) )
      .catch(err => console.log(err));	
	
}//end func

async function afterrptwptappsxl(res){
	//var blob = new Blob(res, {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
	setDowait({show:false});
	
	const blob = await res.blob();
saveAs(blob, dateandtimestring()+".xlsx", {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
//.substring(0, 10)
}//end func

function dateandtimestring(){
const date = new Date();

const strdate = (1+1*date.toLocaleDateString("en-US", { day: 'numeric' })) + "."+ date.toLocaleDateString("en-US", { month: 'short' })             + "." + date.toLocaleDateString("en-US", { year: 'numeric' });
//console.log("strdate: "+strdate);

//const temp="2024-12-12T21_04_08.301Z".substring(11,16).replace("_",".");
let strtime=date.toISOString().substring(11,19).replace(":",".");
strtime=strtime.replace(":",".");
//console.log("strtime: "+strtime);	
return strdate+" "+strtime
}//end func

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



async function submitform1(e){
	
	e.preventDefault();
	
	const form1=document.getElementById("form1");
	// This is the important part, test if form is valid
	if (form1.checkValidity() === false){
		// This is the magic function that displays the validation errors to the user
		form1.reportValidity();   
		return; 
		}//end if
	
	console.log("submitform1 rpt.num: "+rpt.num);
	
	if (rpt.num==1)
		rptwptappsxl();
	else if (rpt.num==2)
		rptapprovedwpxl();
	
}//end func



	
	
  return (
    <>
	
		<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Reports</p>
			
			<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >Start Date: </td>
			<td align='left' ><input type="date" name="date1" value={crit.date1} required onChange={ (e)=>{handleChange(e);} } value={crit.date1} /></td>
			</tr>
			<tr>
			<td align='right' >End Date: </td>
			<td align='left' ><input type="date" name="date2" value={crit.date2} required onChange={ (e)=>{handleChange(e);} } value={crit.date2} /></td>
			</tr>
			<tr>
			<td align='right' >Processing Area: </td>
			<td align='left' >
				<select name="processarea" value={crit.processarea}  onChange={ (e)=>{handleChange(e);} }>
				<option value="" ></option>
				{processareaopts}
				</select>
			</td>
			</tr>
			<tr>
			<td align='right' >Application Status: </td>
			<td align='left' >
				<select name="status" value={crit.status}  onChange={ (e)=>{handleChange(e);} }>
				<option value="" ></option>
				{statusopts}
				</select>
			</td>
			</tr>
			<tr>
			<td align='right' >Review Type: </td>
			<td align='left' >
				<select name="review_type" value={crit.review_type}  onChange={ (e)=>{handleChange(e);} } >
				<option value="" ></option>
				{reviewtypeopts}
				</select>
			</td>
			</tr>


			<tr>
			<td align='right' >
				APS Applications Report By Date:
			</td>
			<td align='left' >
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.show && <button className="button"  onClick={(e)=>{setRpt({num:1});}} >generate report</button>}
			</td>
			</tr>

			<tr>
			<td align='right' >
				Processing Work Permits Report By F.Y. 2024/2025:
			</td>
			<td align='left' >
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.show && <button className="button" onClick={(e)=>{setRpt({num:2});}}  >generate report</button>}
			</td>
			</tr>
			
			</tbody>
			</table>
			</form>

<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;